import { render, staticRenderFns } from "./QuizAnswerType.vue?vue&type=template&id=b3686a4a&"
import script from "./QuizAnswerType.vue?vue&type=script&lang=js&"
export * from "./QuizAnswerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports